import { node, icon, isMapycz } from "./utils";
import { setItem } from "~/util/cookies";

/**
 * Ziskani nazvu eventu pro kolecko na mysi.
 */
function getWheelEventName(): string {
	if ("onwheel" in window) {
		return "wheel";
	}
	if ("onmousewheel" in window) {
		return "mousewheel";
	}

	return "DOMMouseScroll";
}

/**
 * Cancel event.
 */
function cancelEvent(event: Event) {
	event.preventDefault();
}

/**
 * Cancel event.
 */
function stopEvent(event: Event) {
	event.stopPropagation();
}

/**
 * Pokud pouzivame gesta 2 prsty pro rotaci na mobilu, tak to cas od casu vraci silene peak hodnoty.
 * Proto jsem se to snazil normalizovat do 3. kvadrantu
 */
function normRotationStep(val: number): number {
	let diff = 0;
	const absVal = Math.abs(val);

	if (absVal >= 90 && absVal < 180) {
		diff = val < 0 ? -180 : 180;
	} else if (absVal >= 180 && absVal < 270) {
		diff = val < 0 ? -270 : 270;
	} else if (absVal >= 270 && absVal <= 360) {
		diff = val < 0 ? -360 : 360;
	}

	return val - diff;
}

/**
 * Znamenka z hodnoty.
 */
function sign(value: number): number {
	if (value > 0) {
		return 1;
	}
	if (value < 0) {
		return -1;
	}

	return 0;
}

/**
 * Je aktivni hlaseni chyby? Zakazeme +-.
 */
function isReportDefectActive(): boolean {
	if (isMapycz()) {
		return Mapy.getComponent("reportDefect").isActive();
	}

	return false;
}
export default class Melown3dUI {
	/**
	 * UI ovladani pro 3D.
	 *
	 * @param  {Melown3d} instance 3d
	 * @param  {Object} conf Konfigurace konstant pro ovladani
	 */
	_const: {
		[key: string]: string;
	};

	_conf: {
		stopAutoRotationOnInteraction: boolean;
		panSensitivity: number;
		rotateSensitivity: number;
		zoomSensitivity: number;
		touchSensitivity: number;
		inFrame: boolean;
		trans: {
			[key: string]: string;
		};
	};

	_binds: {
		[key: string]: any;
	};

	_buttons: {
		[key: string]: any;
	};

	_buttonsOrder: Array<string>;

	_presenter: any;

	_shiftPress: boolean;

	_isDragged: boolean;

	_touchCoords: any;

	_wheelEventName: string;

	_interaction: boolean;

	_dom: {
		[key: string]: any;
	};

	_mouse: {
		button: number;
		start: any;
		coords: any;
		ignore: boolean;
	};

	_gesture: {
		start: boolean;
		scale: number;
		rotation: number;
	};

	_isDialogOpen: boolean;

	constructor(presenter, conf) {
		this._const = {
			DIALOG_VISIBLE_CLASS: "info-dialog-visible",
		};

		this._conf = {
			stopAutoRotationOnInteraction: true,
			panSensitivity: 0.5,
			rotateSensitivity: 0.25,
			zoomSensitivity: 1,
			touchSensitivity: 0.5,
			inFrame: false,
			trans: {},
		};

		// conf update
		for (const key in conf) {
			if (conf[key]) {
				this._conf[key] = conf[key];
			}
		}

		// binds holder
		this._binds = {};
		this._buttons = {};
		this._buttonsOrder = ["elevation", "rotateLeft", "rotateRight", "pitchUp", "pitchDown", "info"]; // "autoRotation", "zoomOut", "zoomIn",
		this._presenter = presenter;
		this._shiftPress = false;
		this._isDragged = false;
		this._touchCoords = null;
		this._wheelEventName = getWheelEventName();
		this._interaction = true;

		this._dom = {
			container: node("div", { className: "ui-controls" }),
			infoDialog: null,
		};

		this._mouse = {
			button: 0,
			start: null,
			coords: null,
			ignore: false,
		};

		this._gesture = {
			start: false,
			scale: 1,
			rotation: 0,
		};

		this._build();
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		this._dom.container.remove();

		if (this._dom.infoDialog) {
			this._dom.infoDialog.remove();
		}

		// events
		document.removeEventListener("keydown", this._bindEvent("keyDown"), false);
		document.removeEventListener("keyup", this._bindEvent("keyUp"), false);
		document.removeEventListener("keypress", this._bindEvent("keyPress"), false);
	}

	disableElevation(disable = false) {
		const elevBtn = this._dom.container.querySelector("button.elevation");

		if (elevBtn) {
			elevBtn.classList[disable ? "add" : "remove"]("deactive");
		}
	}

	activeElevation(active = false) {
		const elevBtn = this._dom.container.querySelector("button.elevation");

		if (elevBtn) {
			elevBtn.classList[active ? "add" : "remove"]("active");

			if (active) {
				setItem("Mapy3DSE", "1");
			} else {
				setItem("Mapy3DSE", "0");
			}
		}
	}

	/**
	 * Je otevreny info dialog?
	 */
	isDialogOpen() {
		return this._isDialogOpen;
	}

	setInteraction(bool = true) {
		this._interaction = bool;
	}

	/**
	 * Nabinduje event - vlozi do objektu _binds, funkce podle nazvu
	 */
	_bindEvent(name: string, isBtn = false): () => void {
		const bindName = name + (isBtn ? "Click" : "");
		const methodName = `_${name}${isBtn ? "Click" : ""}`;

		if (methodName in this && !(bindName in this._binds)) {
			this._binds[bindName] = this[methodName].bind(this);
		}

		return this._binds[bindName];
	}

	/**
	 * Vytvoreni cudlu podle jeho nazvu.
	 */
	_createBtn(btnName: string): HTMLButtonElement {
		const btn = node("button", { className: btnName });

		btn.setAttribute("type", "button");
		btn.classList.add("noprint");
		btn.addEventListener("click", () => {
			this._runOper(btnName);
		});

		return btn;
	}

	/**
	 * Vytvorime tlacitka, bind eventu.
	 */
	_build() {
		if (this._conf.inFrame) {
			return;
		}

		// vytvorime tlacitka podle zadaneho poradi
		this._buttonsOrder.forEach(btnName => {
			const btn = node("button", { className: btnName });

			btn.setAttribute("type", "button");
			btn.classList.add("noprint");
			btn.addEventListener("click", () => {
				this._runOper(btnName);
			});

			// specialne elevation
			if (btnName.indexOf("elevati") > -1) {
				btn.appendChild(icon(btnName));
				btn.appendChild(node("span", { className: "copyright" }, ""));

				this._dom.container.appendChild(btn);
			} else if (btnName.indexOf("elevati") === -1) {
				this._dom.container.appendChild(btn);
			}
		});

		const presenterCont = this._presenter.getContainer();

		presenterCont.appendChild(this._dom.container);

		// events
		presenterCont.addEventListener("selectstart", cancelEvent, false);
		presenterCont.addEventListener("contextmenu", cancelEvent, false);

		presenterCont.addEventListener("mousedown", this._bindEvent("mouseDown"), false);
		presenterCont.addEventListener("mousemove", this._bindEvent("mouseMove"), false);
		presenterCont.addEventListener("mouseup", this._bindEvent("mouseUp"), false);
		presenterCont.addEventListener(this._wheelEventName, this._bindEvent("mouseWheel"), false);
		presenterCont.addEventListener("dblclick", this._bindEvent("dblClick"), false);

		presenterCont.addEventListener("touchstart", this._bindEvent("touchStart"), navigator.userAgent.indexOf("rv:11.0") === -1 ? { passive: false, capture: false } : false);
		presenterCont.addEventListener("touchend", this._bindEvent("touchEnd"), false);
		presenterCont.addEventListener("touchmove", this._bindEvent("touchMove"), false);

		presenterCont.addEventListener("gesturestart", this._bindEvent("gestureStart"), false);
		presenterCont.addEventListener("gestureend", this._bindEvent("gestureEnd"), false);
		presenterCont.addEventListener("gesturechange", this._bindEvent("gestureChange"), false);

		document.addEventListener("keydown", this._bindEvent("keyDown"), false);
		document.addEventListener("keyup", this._bindEvent("keyUp"), false);
		document.addEventListener("keypress", this._bindEvent("keyPress"), false);
	}

	/**
	 * Zobrazeni/skryti info dialogu.
	 */
	_toggleInfoDialog() {
		if (!this._dom.infoDialog) {
			this._dom.infoDialog = node("div", { className: "info-dialog" });
			this._dom.infoDialogContent = node("div", { className: "info-dialog-content" });
			this._dom.infoDialogContent.appendChild(node("h2", { innerHTML: this._conf.trans.infoTitle || "" }));
			this._dom.infoDialogContent.appendChild(node("p", { className: "pan", innerHTML: this._conf.trans.infoPan || "" }));
			this._dom.infoDialogContent.appendChild(node("p", { className: "zoom", innerHTML: this._conf.trans.infoZoom || "" }));
			this._dom.infoDialogContent.appendChild(node("p", { className: "pitch", innerHTML: this._conf.trans.infoPitch || "" }));
			this._dom.infoDialog.appendChild(this._dom.infoDialogContent);

			// events
			this._dom.infoDialog.addEventListener(this._wheelEventName, stopEvent, false);
			this._dom.infoDialog.addEventListener("touchmove", stopEvent, false);

			const closeButton = node("div", { className: "info-dialog-close" });

			this._dom.infoDialog.appendChild(closeButton);
			closeButton.addEventListener("click", () => {
				this._toggleInfoDialog();
			});
		}

		const cont = this._presenter.getContainer();

		if (this._dom.infoDialog.parentNode) {
			this._dom.infoDialog.remove();
			cont.classList.remove(this._const.DIALOG_VISIBLE_CLASS);
			this._isDialogOpen = false;
		} else {
			cont.appendChild(this._dom.infoDialog);
			cont.classList.add(this._const.DIALOG_VISIBLE_CLASS);
			this._isDialogOpen = true;
		}
	}

	/**
	 * Zavreni autorotace, pokud je nastaven priznak.
	 */
	_closeAutoRotation() {
		if (this._presenter.isAutoRotationEnabled() && this._conf.stopAutoRotationOnInteraction) {
			this._presenter.setAutoRotation(false);
		}
	}

	/**
	 * Zavolej operaci nad 3D + info dialog.
	 */
	_runOper(oper: string) {
		let panSensitivity = 1;

		if (this._presenter.conf.melownPan) {
			panSensitivity = this._presenter.options.newPanSensitivity;
		}
		switch (oper) {
			case "autoRotation":
				this._presenter.setAutoRotation();
				break;

			case "rotateLeft":
				this._presenter.rotate(-1, 0, true);
				break;

			case "rotateRight":
				this._presenter.rotate(1, 0, true);
				break;

			case "zoomOut":
				this._presenter.zoomToCoords(1);
				break;

			case "zoomIn":
				this._presenter.zoomToCoords(-1);
				break;

			case "pitchUp":
				this._presenter.rotate(0, -1, true);
				break;

			case "pitchDown":
				this._presenter.rotate(0, 1, true);
				break;

			case "panUp":
				this._presenter.pan(0, 1 * panSensitivity, true);
				break;

			case "panDown":
				this._presenter.pan(0, -1 * panSensitivity, true);
				break;

			case "panLeft":
				this._presenter.pan(1 * panSensitivity, 0, true);
				break;

			case "panRight":
				this._presenter.pan(-1 * panSensitivity, 0, true);
				break;

			case "info":
				this._toggleInfoDialog();
				break;

			case "elevation":
				// eslint-disable-next-line no-case-declarations
				const btn = this._dom.container.querySelector("button.elevation");

				if (btn && !btn.classList.contains("deactive")) {
					const active = btn.classList.contains("active");

					this._presenter.elevation(!active);
					this.activeElevation(!active);
				}
				break;
			default:
				break;
		}
	}

	/**
	 * Klik mysi.
	 */
	_mouseDown(event: MouseEvent) {
		this._mouse.start = [event.clientX, event.clientY];
		this._mouse.coords = [event.screenX, event.screenY];
		this._mouse.button = event.button;
		this._isDragged = false;

		document.addEventListener("mouseup", this._bindEvent("documentMouseUp"), false);
	}

	/**
	 * Pusteni tlacitka mysi.
	 */
	_mouseUp() {
		this._mouse.start = null;
		this._mouse.coords = null;
		this._mouse.button = -1;

		if (this._isDragged) {
			this._presenter.getContainer().classList.remove("cur-move");
			this._isDragged = false;
		}
	}

	/**
	 * Pusteni mysi mimo 3d.
	 */
	_documentMouseUp() {
		if (!this._mouse.coords) {
			return;
		}

		this._mouse.start = null;
		this._mouse.coords = null;
		this._mouse.button = -1;

		if (this._isDragged) {
			this._presenter.getContainer().classList.remove("cur-move");
			this._isDragged = false;
		}

		document.addEventListener("mouseup", this._bindEvent("documentMouseUp"), false);
	}

	/**
	 * Pohyb mysi.
	 */
	_mouseMove(event: MouseEvent) {
		if (this._mouse.coords && (!this._mouse.ignore || this._mouse.button === 2 || this._mouse.button === 1)) {
			event.preventDefault();

			this._closeAutoRotation();

			let dx = event.screenX - this._mouse.coords[0];
			let dy = event.screenY - this._mouse.coords[1];

			if (this._mouse.button === 0) {
				if (this._shiftPress) {
					dx *= this._conf.rotateSensitivity;
					dy *= this._conf.rotateSensitivity;

					this._presenter.rotate(-dx, -dy);
				} else {
					dx *= this._conf.panSensitivity;
					dy *= this._conf.panSensitivity;

					this._presenter.pan(dx, dy);

					if (!this._isDragged) {
						this._isDragged = true;

						if (!this._presenter.isCardOpen()) {
							this._presenter.getContainer().classList.add("cur-move");
						}
					}
				}
			} else if (this._mouse.button === 2 || this._mouse.button === 1) {
				dx *= this._conf.rotateSensitivity;
				dy *= this._conf.rotateSensitivity;

				this._presenter.rotate(-dx, -dy);
			}

			this._mouse.coords = [event.screenX, event.screenY];
		}
	}

	/**
	 * Kolecko mysi.
	 */
	_mouseWheel(event: WheelEvent) {
		if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) { // posun po vodorovne ose
			return;
		}

		event.preventDefault();

		this._closeAutoRotation();

		// wheel || mousewheel || dommousescroll
		const delta = event.deltaY || -event.detail;
		const bcr = this._presenter.getContainer().getBoundingClientRect();

		this._presenter.zoomToCoords(delta < 0 ? -1 : 1, event.clientX - bcr.left, event.clientY - bcr.top);
	}

	/**
	 * Dvojity klik mysi.
	 */
	_dblClick(event: MouseEvent) {
		const target = event.target as HTMLElement;
		const targetName = target ? target.nodeName.toLowerCase() : "";

		if (targetName !== "canvas") {
			return;
		}

		this._runOper("zoomIn");
	}

	/**
	 * Zacatek gesta.
	 */
	_gestureStart() {
		this._gesture.start = true;
		this._gesture.scale = 1;
		this._gesture.rotation = 0;
	}

	/**
	 * Konec gesta.
	 */
	_gestureEnd() {
		this._gesture.start = false;
	}

	/**
	 * Zmena gesta.
	 */
	_gestureChange(event: any) {
		if (this._gesture.start) {
			event.preventDefault();

			this._closeAutoRotation();

			const scaleStep = this._gesture.scale / event.scale;

			this._gesture.scale = event.scale;

			const rotationStep = event.rotation - this._gesture.rotation;

			this._gesture.rotation = event.rotation;

			// zoom
			this._presenter.zoom((scaleStep - 1) * this._conf.zoomSensitivity);
			// yaw
			this._presenter.rotate(-normRotationStep(-rotationStep * 2/3));
		}
	}

	/**
	 * Zacatek touch eventu.
	 */
	_touchStart(event: TouchEvent) {
		if (event.touches.length >= 1) {
			this._mouse.ignore = true;
			this._touchCoords = [];

			for (let index = 0, len = event.touches.length; index < len; index++) {
				const touch = event.touches[index];

				this._touchCoords.push([touch.screenX, touch.screenY]);
			}
		}
	}

	/**
	 * Konec touch eventu.
	 */
	_touchEnd() {
		this._touchCoords = null;
		this._mouse.ignore = false;
	}

	/**
	 * Pohyb pri touch eventu.
	 */
	_touchMove(event: TouchEvent) {
		event.preventDefault();

		if (this._touchCoords && event.touches.length === 1 && this._touchCoords.length === 1 && this._touchCoords && this._mouse.button !== 2) {
			this._closeAutoRotation();

			const touch = event.touches[0];
			const dx = (touch.screenX - this._touchCoords[0][0]) * this._conf.touchSensitivity;
			const dy = (touch.screenY - this._touchCoords[0][1]) * this._conf.touchSensitivity;

			this._presenter.pan(dx, dy);
		} else if (this._touchCoords && this._touchCoords.length === 2 && event.touches.length === 2) {
			const t1 = event.touches[0];
			const t2 = event.touches[1];

			const dy1 = t1.screenY - this._touchCoords[0][1];
			const dy2 = t2.screenY - this._touchCoords[1][1];
			const dx1 = t1.screenX - this._touchCoords[0][0];
			const dx2 = t2.screenX - this._touchCoords[1][0];

			if (Math.abs(sign(dy1) - sign(dy2)) <= 1 && Math.abs(dy1 + dy2) > Math.abs(dx1 + dx2)) {
				this._closeAutoRotation();

				this._presenter.rotate(0, -dy1 * this._conf.touchSensitivity);
			}
		}

		this._touchCoords = [];

		for (let index = 0, len = event.touches.length; index < len; index++) {
			const touch = event.touches[index];

			this._touchCoords.push([touch.screenX, touch.screenY]);
		}
	}

	/**
	 * Zmacknuti klavesy.
	 */
	_keyDown(event: KeyboardEvent) {
		if (!this._interaction) {
			return;
		}

		const target = event.target as HTMLElement;
		const element = target.nodeName.toLowerCase();

		if (element === "input" || element === "textarea" || event.metaKey || event.altKey) {
			return;
		}

		switch (event.key) {
			case "Left":
			case "ArrowLeft":
				this._runOper("panLeft");
				break;

			case "Up":
			case "ArrowUp":
				this._runOper("panUp");
				break;

			case "Right":
			case "ArrowRight":
				this._runOper("panRight");
				break;

			case "Down":
			case "ArrowDown":
				this._runOper("panDown");
				break;

			case "Esc":
			case "Escape":
				if (this._isDialogOpen) {
					event.stopPropagation();

					this._toggleInfoDialog();
				}
				break;

			case "Control":
			case "Shift":
				this._shiftPress = true;
				break;

			default:
				return;
		}

		event.preventDefault();
	}

	/**
	 * Zmacknuti klavesy.
	 */
	_keyPress(event: KeyboardEvent) {
		if (isReportDefectActive()) {
			return;
		}

		const target = event.target as HTMLElement;
		const element = target.nodeName.toLowerCase();

		if (element === "input" || element === "textarea") {
			return;
		}

		switch (event.key) {
			case "+":
				this._runOper("zoomIn");
				break;

			case "-":
				this._runOper("zoomOut");
				break;

			default:
				break;
		}
	}

	/**
	 * Pusteni klavesy.
	 */
	_keyUp(event: KeyboardEvent) {
		event.preventDefault();

		switch (event.key) {
			case "Control":
			case "Shift":
				this._shiftPress = false;
				break;

			default:
				break;
		}
	}
}
